import type { VariantWithProductData } from "@bcc/components/products/products-table/types";
import type { DemoStore } from "./products.demo";
import { useVendorContext } from "@client-shared/providers/vendor";
import { useMemo } from "react";
import { useDemoDataModule } from "./use-demo-data-module";

const loadProductsDemo = () => import("./products.demo");

const FALLBACK_VENDOR_KEY = "demo-vendor";

export interface DemoProductsView {
  variantData: VariantWithProductData[];
  /** Sample store for the Map Products and Add Product dialogs; absent until the fixtures load */
  store?: DemoStore;
  /** True for the one tick while the fixtures load */
  isLoading: boolean;
}

/** Sample product rows for the products table while the tour runs; undefined in normal use */
export function useDemoProducts(): DemoProductsView | undefined {
  const { isActive, module } = useDemoDataModule(loadProductsDemo);
  const [{ currentVendor }] = useVendorContext();
  const vendorKey = currentVendor?.vendorKey ?? FALLBACK_VENDOR_KEY;
  // Joined so the memo stays stable across renders that hand back an equal list
  const shipToKey = (currentVendor?.properties?.shipTo ?? []).join(";");

  return useMemo(() => {
    if (!isActive) return undefined;
    if (!module) return { variantData: [], isLoading: true };
    return {
      variantData: module.buildDemoVariantData({ shipTo: shipToKey ? shipToKey.split(";") : [] }),
      store: module.buildDemoStore({ vendorKey }),
      isLoading: false,
    };
  }, [isActive, module, shipToKey, vendorKey]);
}
